import httpClient from "@/services/base.service.js";

export default {
  staticimage: function () {
    return httpClient.get("/api/v1/map/staticimage");
  }
};
